module.exports = __webpack_public_path__ + "static/media/allGreenLogo-lt.601c41e3.png";